<template>
  &copy; {{ providerDetails.provider }} ABN {{ providerDetails.abn }}, AFSL {{ licence }}.
  {{ providerDetails.address }}
</template>

<script lang="ts" setup>
import { useProviderDetails } from '@/composables/useProviderDetails'

const { providerDetails, licence } = useProviderDetails()
</script>
